import { DatePicker } from 'antd';
import { FC, Dispatch, SetStateAction } from 'react';
import moment, { Moment } from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/lt';
import 'moment/locale/ro';

import { useTranslate } from 'hooks';

import { LOCALES } from 'utils/constants';
import { language } from 'utils/i18n';

import './index.scss';

type RangeDatePickerProps = {
	onChange?: Dispatch<SetStateAction<any | undefined>>;
	range?: any;
	minDate?: Moment;
	maxDate?: Moment;
};

export const RangeDatePicker: FC<RangeDatePickerProps> = ({
	onChange,
	range,
	minDate,
	maxDate,
}) => {
	const { dateFromText, dateToText } = useTranslate(['dateFromText', 'dateToText']);

	return (
		<div className="rangeFilter">
			<DatePicker
				value={range.startDate}
				locale={(LOCALES as any)[language]}
				allowClear={false}
				defaultPickerValue={range?.startDate}
				defaultValue={range?.startDate}
				inputReadOnly
				format="YYYY-MM-DD"
				placeholder={dateFromText}
				disabledDate={(d) =>
					minDate
						? !d || d.isAfter(range?.endDate) || d.isBefore(minDate)
						: range?.endDate
						? !d || d.isAfter(range?.endDate)
						: false
				}
				onChange={(e) => {
					if (onChange) {
						onChange({ ...range, startDate: moment(e) });
					}
				}}
			/>
			<div className="rangeFilter__separator" />
			<DatePicker
				value={range.endDate}
				locale={(LOCALES as any)[language]}
				defaultPickerValue={range?.endDate}
				defaultValue={range?.endDate}
				inputReadOnly
				allowClear={false}
				format="YYYY-MM-DD"
				placeholder={dateToText}
				disabledDate={(d) =>
					maxDate
						? !d || d.isAfter(maxDate) || d.isSameOrBefore(range?.startDate)
						: range?.startDate
						? !d || d.isAfter(moment()) || d.isSameOrBefore(range?.startDate)
						: false
				}
				onChange={(e) => {
					if (onChange) {
						onChange({ ...range, endDate: moment(e).endOf('day') });
					}
				}}
			/>
		</div>
	);
};
